module.exports = __webpack_public_path__ + "static/media/05.f690f393.png";